import { useTranslate } from "@lobby/ocb-intl";
import { clsx } from "clsx";
import { PropsWithChildren } from "react";

export default function ErrorPlaceholder({
  className,
  children,
}: PropsWithChildren<{
  className?: string;
}>) {
  const { $t } = useTranslate();

  return (
    <div className={clsx("error-placeholder", className)}>
      <div>
        <p>{$t({ defaultMessage: "An error has occurred" })}</p>
        {children}
      </div>
    </div>
  );
}
